import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true,
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: 'rt_tt_DMSystem', icon: 'dashboard' },
      },
    ],
  },
  {
    /* 主板信息 */
    meta: {
      //title: '主板管理',
      title: 'rt_tt_MbManage',
      icon: 'component',
    },

    path: '/zbxx',
    component: Layout,
    children: [
      // {
      //   path: '/zbxx/index',
      //   name: 'zbxx',
      //   component: () => import('@/views/zbxx/index-all'),
      //   meta: { title: '主板信息', icon: 'component' },
      // },
      {
        path: '/rtctl/index',
        name: 'NEW',
        component: () => import('@/views/zbxx/index-2024'),
        meta: { title: 'rt_tt_MbControlNew', icon: 'component' },
      },
      {
        path: '/zbxx/index/adv',
        name: 'advzbxx',
        component: () => import('@/views/zbxx/index-all-task'),
        meta: { title: 'rt_tt_MbInfo', icon: 'component' },
      },
      {
        path: '/yxjl/index',
        name: 'YXJL',
        component: () => import('@/views/yxjl/index'),
        meta: { title: 'rt_tt_MbRunRecord', icon: 'bug' },
      },
    ],
  },
  {
    /* 主题编辑 */
    path: '/ztbj',
    name: 'ZTBJ',
    component: Layout,
    redirect: '/ztbj/ztbj',
    meta: {
      title: 'rt_tt_ThemeEdit',
      icon: 'nested',
    },
    children: [
      {
        path: 'ztbj/index',
        name: 'ztbj',
        component: () => import('@/views/ztbj/ztbj/index'),
        meta: { title: 'rt_tt_ThemeEdit' },
      },
      {
        path: 'cjbj/index',
        name: 'cjbj',
        component: () => import('@/views/ztbj/cjbj/index'),
        meta: { title: 'rt_tt_ThmSceneEdit' },
        hidden: true,
      },
      {
        path: 'cjbj/index-task-split',
        name: 'cjbj-task',
        component: () => import('@/views/ztbj/cjbj/index-task-split'),
        meta: { title: 'rt_tt_ThmSceneEdit' },
        hidden: true,
      },
      {
        path: 'djbj/index',
        name: 'djbj',
        component: () => import('@/views/ztbj/djbj/index'),
        meta: { title: 'rt_tt_ThmDevEdit' },
        hidden: true,
      },
      {
        path: 'rwbj/index',
        name: 'rwbj',
        component: () => import('@/views/ztbj/rwbj/index'),
        meta: { title: 'rt_tt_ThmTaskEdit' },
        hidden: true,
      },
    ],
  },
  // {
  //   /* 信息看板 */
  //   path: '/xxkb',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'xxkb',
  //       component: () => import('@/views/xxkb/index'),
  //       meta: { title: '信息看板', icon: 'dashboard' }
  //     }
  //   ]
  // },
  {
    /* 系统设置 */
    path: '/xtsz',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'xtsz',
        component: () => import('@/views/xtsz/index'),
        meta: { title: 'rt_tt_SystemSetting', icon: 'form' },
      },
    ],
  },
]

export const asyncRoutes = [
  // New organization/RBAC UI stays behind the release-window feature flag until BE-15.
  {
    path: '/yhgl/index',
    redirect: '/rbac/users',
    hidden: true,
    meta: { rbac: true, roles: ['sivaadmin', 'admin', 'subadmin', 'koradmin', 'store_manager'] }
  },
  {
    path: '/ssj/index',
    redirect: '/org-board/platform',
    hidden: true,
    meta: { rbac: true, roles: ['sivaadmin', 'admin', 'platform_staff'] }
  },
  {
    path: '/org',
    component: Layout,
    meta: { rbac: true, roles: ['sivaadmin', 'admin', 'subadmin', 'koradmin'], title: 'rt_org_management', icon: 'tree' },
    children: [{ path: 'index', name: 'organization-management', component: () => import('@/views/org/index'), meta: { rbac: true, roles: ['sivaadmin', 'admin', 'subadmin', 'koradmin'], title: 'rt_org_management' } }]
  },
  {
    path: '/rbac',
    component: Layout,
    meta: { rbac: true, roles: ['sivaadmin', 'admin', 'subadmin', 'koradmin', 'store_manager', 'platform_staff'], title: 'rt_org_access', icon: 'user' },
    children: [
      { path: 'users', name: 'organization-users', component: () => import('@/views/rbac/users'), meta: { rbac: true, roles: ['sivaadmin', 'admin', 'subadmin', 'koradmin', 'store_manager', 'platform_staff'], title: 'rt_org_users' } },
      { path: 'roles', name: 'role-permissions', component: () => import('@/views/rbac/roles'), meta: { rbac: true, roles: ['sivaadmin'], title: 'rt_role_permissions' } }
    ]
  },
  {
    path: '/org-board',
    component: Layout,
    meta: { rbac: true, roles: ['sivaadmin', 'admin', 'subadmin', 'koradmin', 'store_manager', 'employee', 'platform_staff'], title: 'rt_device_resources', icon: 'list' },
    children: [
      { path: 'my', name: 'my-boards', component: () => import('@/views/board/my'), meta: { rbac: true, roles: ['sivaadmin', 'admin', 'subadmin', 'koradmin', 'store_manager', 'employee', 'platform_staff'], title: 'rt_my_boards' } },
      { path: 'org', name: 'organization-boards', component: () => import('@/views/board/org'), meta: { rbac: true, roles: ['sivaadmin', 'admin', 'subadmin', 'koradmin', 'store_manager'], title: 'rt_org_boards' } },
      { path: 'platform', name: 'platform-boards', component: () => import('@/views/board/platform'), meta: { rbac: true, roles: ['sivaadmin', 'admin', 'platform_staff'], title: 'rt_platform_boards' } }
    ]
  },
  {
    path: '/org-theme',
    component: Layout,
    meta: { rbac: true, roles: ['sivaadmin', 'admin', 'subadmin', 'koradmin', 'store_manager'], title: 'rt_org_themes', icon: 'list' },
    children: [{ path: 'org', name: 'organization-themes', component: () => import('@/views/theme/org'), meta: { rbac: true, roles: ['sivaadmin', 'admin', 'subadmin', 'koradmin', 'store_manager'], title: 'rt_org_themes' } }]
  },
  // {
  //   path: '/preview',
  //   component: Layout,
  //   meta: { roles: ['sivastaff','vipuser'], title: '内测功能', icon: 'nested' },
  //   children: [
  //     {
  //       path: '/rtctl/index25',
  //       name: 'NEW',
  //       component: () => import('@/views/zbxx/index-2025'),
  //       meta: { title: '(2025)PC端场控', icon: 'component' },
  //     },
  //   ]
  // },
  {
    path: '/yhgl',
    component: Layout,
    meta: { legacyOnly: true, roles: ['admin', 'subadmin', 'koradmin'], title: 'rt_tt_UserManage', icon: 'user' },
    children: [
      {
        /* 用户管理 */
        path: '/yhgl/index',
        name: 'yhgl',
        component: () => import('@/views/yhgl/index'),
        meta: { title: 'rt_tt_UserManage', icon: 'user' },
      },
    ],
  },
  {
    path: '/ssj',
    component: Layout,
    meta: { legacyOnly: true, roles: ['admin', 'sivastaff'], title: 'rt_tt_DevManage', icon: 'list' },
    children: [
      {
        /* 主板管理 */
        path: '/ssj/index',
        name: 'ssj',
        component: () => import('@/views/ssj/index'),
        meta: { title: 'rt_tt_DevManage', icon: 'list' },
      },
    ],
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true },
]

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
